import { ArticleStatus } from "../../api/Articles/interfaces";

export const ARTICLES_STATUSES: Record<ArticleStatus, 1 | 2 | 3> = {
  draft: 1,
  published: 2,
  archived: 3,
};
